import validate from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/validate.mjs";
import check_45session_45global from "/opt/buildhome/repo/middleware/checkSession.global.ts";
export const globalMiddleware = [
  validate,
  check_45session_45global
]
export const namedMiddleware = {}